import CouponFormPage from "./CouponFormPage"

export default function CouponAdd() {
    return <CouponFormPage mode="create" />
}
